import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ReactComponent as ArrowDown } from "../../../../../../assets/icons/ArrowDown.svg";
import { ReactComponent as ArrowUp } from "../../../../../../assets/icons/ArrowUp.svg";
import useSpecial from "../../../../../../hooks/useSpecial";
import {
  MainBox,
  StyledIcon,
  StyledTitle,
  SubBox,
} from "../../../../Layout/Menus/components/Box";
import { LinkType, MainType } from "../../../../Layout/constants";

interface Props {
  mainLink: MainType;
  setIdx: () => void;

  setClose: () => void;
  subLink: LinkType[];
  open: boolean;
}
const Box: React.FC<Props> = ({
  mainLink,
  subLink,
  setIdx,
  open,
  setClose,
}) => {
  const { pathname } = useLocation();
  const { special } = useSpecial();

  const [isOpen, setOpen] = useState(open);

  useEffect(() => {
    setOpen(open);
  }, [open]);

  return (
    <div>
      <MainBox
        open={isOpen}
        onClick={() => {
          if (isOpen === true) setClose();
          else setIdx();
        }}
      >
        <StyledTitle>
          <StyledIcon> {mainLink.icon}</StyledIcon>
          {mainLink.name}
        </StyledTitle>
        {isOpen ? <ArrowUp /> : <ArrowDown />}
      </MainBox>
      <>
        {subLink.map(
          (data, index) =>
            data.name && (
              <Link
                to={`${data.path}${special ? `${special}` : ""}`}
                key={index}
              >
                <SubBox
                  open={isOpen}
                  isNow={
                    pathname === "/"
                      ? data.path === "/"
                      : data.path === pathname
                  }
                >
                  {data.name}
                </SubBox>
              </Link>
            )
        )}
      </>
    </div>
  );
};

export default Box;
